import React from 'react';
import { useActivation } from '@context/MobileOne';
import { FeedbackImage, ScrollToTop } from '@core/index';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { appButtonType, appIconsPath } from '@utils/globalConstant';
import useCmsImage from '@utils/useCmsImage';

export const OverviewSuccess = () => {
  const { nextStep, setShowActivationHeader, setStep8SubStep } = useActivation();

  // Const
  const imageContent = useCmsImage('ek_reg_feedback_suc_web_bg');
  const headerContent = tA11y('ek_reg_feedback_hdl1');
  const copyTextContent = tA11y('ek_reg_feedback_txt1');
  const buttonContent = tA11y('ek_reg_feedback_btn1');

  return (
    <>
      <ScrollToTop>
        <FeedbackImage
          image={imageContent}
          icon={appIconsPath.SUCCESS}
          headingContent={headerContent}
          copyTextContent={copyTextContent}
          buttonContent={buttonContent}
          buttonType={appButtonType.PRIMARY}
          buttonIcon={appIconsPath.ARROW_RIGHT}
          buttonClick={() => {
            setStep8SubStep(0);
            nextStep();
            setShowActivationHeader(true);
          }}
        />
      </ScrollToTop>
    </>
  );
};

export default OverviewSuccess;
